<template>
  <v-card width="100%">
    <v-card-title class="pb-0">{{ $t('schedule.title') }}</v-card-title>
    <v-card-title>{{ $time().format('YYYY/MM/DD') }}</v-card-title>
    <div class="card-content pa-4">
      <v-sheet height="auto">
        <v-calendar class="calendar" type="day" event-color="white" :events="events" :hide-header="true" interval-height="60" @click:event="toAppointment">
          <template v-slot:event="{ event }">
            <appointment-card :event="event"></appointment-card>
          </template>
        </v-calendar>
      </v-sheet>
    </div>
  </v-card>
</template>

<script>
import AppointmentCard from './Part/AppointmentsCard'

export default {
  components: { AppointmentCard },
  data () {
    return {
      today: this.$time().format('YYYY-MM-DD')
    }
  },
  computed: {
    events () {
      return [
        {
          appointments: [
            {
              name: 'AAA',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678',
              start: `${this.today} 12:15`,
              end: `${this.today} 12:45`
            },
            {
              name: 'BBB',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678',
              start: `${this.today} 12:15`,
              end: `${this.today} 12:45`
            },
            {
              name: 'CCC',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678',
              start: `${this.today} 12:15`,
              end: `${this.today} 12:45`
            }
          ],
          start: `${this.today} 12:00`,
          end: `${this.today} 13:00`
        },
        {
          appointments: [
            {
              name: 'AAA',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'BBB',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'CCC',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'CCC',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'CCC',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            }
          ],
          start: `${this.today} 13:00`,
          end: `${this.today} 14:00`
        },
        {
          appointments: [
            {
              name: 'AAA',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'BBB',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'CCC',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'CCC',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            },
            {
              name: 'CCC',
              account: 'ijkl@gmail.com',
              phoneNumber: '0912-345-678'
            }
          ],
          start: `${this.today} 16:00`,
          end: `${this.today} 17:00`
        }
      ]
    }
  },
  methods: {
    toAppointment () {
      this.$router.push('/rentals/appointment')
    }
  }
}
</script>
